module.exports = __webpack_public_path__ + "static/media/logo.88f0ddd4.png";